module.exports = __webpack_public_path__ + "static/media/edit hr dev. nd training.b92e6b78.svg";